import React, { useState, useEffect } from 'react';

const ModalCrearCita = ({
  show,
  onClose,
  onSubmit,
  clientes,
  servicios,
  formData,
  setFormData,
  horasDisponibles,
  horasCargadas,
  esRecurrente,
  setEsRecurrente,
  recurrencia,
  setRecurrencia,
  onCargarHoras,
  loading = false
}) => {
  const [errores, setErrores] = useState({});

  const validar = () => {
    const nuevosErrores = {};

    if (!formData.cliente_id) nuevosErrores.cliente_id = 'Selecciona un cliente';
    if (!formData.servicio_id) nuevosErrores.servicio_id = 'Selecciona un servicio';
    if (!formData.fecha_cita) nuevosErrores.fecha_cita = 'Selecciona una fecha';
    if (!formData.hora_inicio) nuevosErrores.hora_inicio = 'Selecciona una hora';

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validar()) {
      onSubmit();
    }
  };

  const handleClose = () => {
    setErrores({});
    onClose();
  };

  if (!show) return null;

  const inputStyle = {
    border: '2px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#fafafa',
    width: '100%',
    marginTop: '0.5rem',
    transition: 'all 0.2s'
  };

  const errorStyle = {
    color: '#dc2626',
    fontSize: '0.85rem',
    marginTop: '0.25rem'
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '600px', borderRadius: '16px', overflow: 'hidden' }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
          padding: '1.25rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ fontSize: '1.4rem' }}>📅</span>
            <h3 style={{ margin: 0, color: 'white', fontSize: '1.1rem', fontWeight: '700' }}>
              Nueva Cita
            </h3>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          {/* Cliente */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>Cliente *</label>
            <select
              value={formData.cliente_id}
              onChange={(e) => setFormData({ ...formData, cliente_id: e.target.value })}
              style={{ ...inputStyle, borderColor: errores.cliente_id ? '#dc2626' : 'rgba(59, 130, 246, 0.3)' }}
              disabled={loading}
            >
              <option value="">-- Selecciona cliente --</option>
              {clientes.map(c => (
                <option key={c.id} value={c.id}>{c.nombre}</option>
              ))}
            </select>
            {errores.cliente_id && <div style={errorStyle}>{errores.cliente_id}</div>}
          </div>

          {/* Servicio */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>Servicio *</label>
            <select
              value={formData.servicio_id}
              onChange={(e) => {
                setFormData({ ...formData, servicio_id: e.target.value });
                if (formData.fecha_cita) {
                  onCargarHoras(formData.fecha_cita, e.target.value);
                }
              }}
              style={{ ...inputStyle, borderColor: errores.servicio_id ? '#dc2626' : 'rgba(59, 130, 246, 0.3)' }}
              disabled={loading}
            >
              <option value="">-- Selecciona servicio --</option>
              {servicios.map(s => (
                <option key={s.id} value={s.id}>{s.nombre}</option>
              ))}
            </select>
            {errores.servicio_id && <div style={errorStyle}>{errores.servicio_id}</div>}
          </div>

          {/* Fecha */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>Fecha *</label>
            <input
              type="date"
              value={formData.fecha_cita}
              onChange={(e) => {
                setFormData({ ...formData, fecha_cita: e.target.value });
                onCargarHoras(e.target.value, formData.servicio_id);
              }}
              style={{ ...inputStyle, borderColor: errores.fecha_cita ? '#dc2626' : 'rgba(59, 130, 246, 0.3)' }}
              disabled={loading}
            />
            {errores.fecha_cita && <div style={errorStyle}>{errores.fecha_cita}</div>}
          </div>

          {/* Hora */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>Hora *</label>
            {horasCargadas ? (
              <select
                value={formData.hora_inicio}
                onChange={(e) => setFormData({ ...formData, hora_inicio: e.target.value })}
                style={{ ...inputStyle, borderColor: errores.hora_inicio ? '#dc2626' : 'rgba(59, 130, 246, 0.3)' }}
                disabled={loading}
              >
                <option value="">-- Selecciona hora --</option>
                {horasDisponibles.map(hora => (
                  <option key={hora} value={hora}>{hora}</option>
                ))}
              </select>
            ) : (
              <input type="text" placeholder="Cargando horarios..." style={{ ...inputStyle, backgroundColor: '#f3f4f6' }} disabled />
            )}
            {errores.hora_inicio && <div style={errorStyle}>{errores.hora_inicio}</div>}
          </div>

          {/* Notas */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>Notas</label>
            <textarea
              value={formData.notas}
              onChange={(e) => setFormData({ ...formData, notas: e.target.value })}
              placeholder="Notas adicionales..."
              style={{ ...inputStyle, minHeight: '60px', fontFamily: 'inherit' }}
              disabled={loading}
            />
          </div>

          {/* Recurrencia */}
          <div style={{
            padding: '1rem',
            backgroundColor: '#f9fafb',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            border: '1px solid #e5e7eb'
          }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: '600', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={esRecurrente}
                onChange={(e) => setEsRecurrente(e.target.checked)}
                disabled={loading}
              />
              <span>Cita recurrente</span>
            </label>

            {esRecurrente && (
              <div style={{ marginTop: '1rem' }}>
                {/* Tipo */}
                <div style={{ marginBottom: '0.75rem' }}>
                  <select
                    value={recurrencia.tipo}
                    onChange={(e) => setRecurrencia({ ...recurrencia, tipo: e.target.value })}
                    style={{ ...inputStyle, marginTop: '0.25rem' }}
                    disabled={loading}
                  >
                    <option value="diaria">Diaria</option>
                    <option value="semanal">Semanal</option>
                    <option value="quincenal">Quincenal</option>
                    <option value="mensual">Mensual</option>
                  </select>
                </div>

                {/* Fin tipo */}
                <div style={{ marginBottom: '0.75rem' }}>
                  <select
                    value={recurrencia.fin_tipo}
                    onChange={(e) => setRecurrencia({ ...recurrencia, fin_tipo: e.target.value })}
                    style={{ ...inputStyle, marginTop: '0.25rem' }}
                    disabled={loading}
                  >
                    <option value="sesiones">Número de sesiones</option>
                    <option value="fecha">Hasta fecha</option>
                  </select>
                </div>

                {/* Sesiones o Fecha */}
                {recurrencia.fin_tipo === 'sesiones' ? (
                  <input
                    type="number"
                    min="2"
                    max="52"
                    value={recurrencia.num_sesiones}
                    onChange={(e) => setRecurrencia({ ...recurrencia, num_sesiones: parseInt(e.target.value) })}
                    style={{ ...inputStyle, marginTop: '0.25rem' }}
                    disabled={loading}
                  />
                ) : (
                  <input
                    type="date"
                    value={recurrencia.fecha_fin}
                    onChange={(e) => setRecurrencia({ ...recurrencia, fecha_fin: e.target.value })}
                    style={{ ...inputStyle, marginTop: '0.25rem' }}
                    disabled={loading}
                  />
                )}
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Creando...' : 'Crear Cita'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalCrearCita;
